/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const DEFAULT_ERROR_MESSAGE = {
  general: "Something went wrong",
};
